import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import ModalHeader from '../Modal/ModalHeader';

interface CreateReasonInProgressDialogProps {
  closeCreateReasonInProgressDialog: () => void;
  closeExistingCreateNewReasonDialog: () => void;
  openCreateNewReasonDialog: () => void;
}

export const CreateReasonInProgressDialog = ({
  closeCreateReasonInProgressDialog,
  closeExistingCreateNewReasonDialog,
  openCreateNewReasonDialog,
}: CreateReasonInProgressDialogProps) => {
  return (
    <>
      <ModalHeader
        title="Discard progress on creating new Reason?"
        onClose={closeCreateReasonInProgressDialog}
      />
      <DialogContent dividers>
        <Typography variant="body2">
          A Reason’s creation is already in progress. Do you wish to discard it,
          and proceed?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            closeCreateReasonInProgressDialog();
            closeExistingCreateNewReasonDialog();
            openCreateNewReasonDialog();
          }}
        >
          Discard and proceed
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => closeCreateReasonInProgressDialog()}
        >
          Cancel
        </Button>
      </DialogActions>
    </>
  );
};
